var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsCircleCheckmarkOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Circle Checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M52,13.5a36,36,0,1,0,36,36A36,36,0,0,0,52,13.5ZM52,81A31.5,31.5,0,1,1,83.5,49.5,31.53,31.53,0,0,1,52,81ZM47.53,55.33l-7.19-7.19-3.18,3.18L47.53,61.7,68.68,40.48,65.49,37.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCircleCheckmarkOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_CircleCheckmark_Outline_Brand.70571299b03d0d2b66290a28ce1e47ae.svg";
export { ForwardRef as ReactComponent };